export default class MemoUtil {
  static renderMemoContent(pre_content, highlight_words = null) {
    if (!pre_content) return pre_content
    // let rendered_content = pre_content.replace(/(https?:\/\/([^\s<\/\#)）]+)[^\s<)）]*)/g, '<a href="$1" target="_blank">$2</a>'); // 链接可点
    let rendered_content = pre_content.replace(/>([^<]+)</g, (matched) => {
      // let rendered_content = pre_content.replace(/([^>^<]*)</g, function (matched) {
      // 只匹配 html content
      matched = matched.replace(
        /(https:\/\/(v.)*flomoapp.com\/mine\/\?memo_id=(\w+))/g,
        function (matchedLink, p1, p2) {
          let slug = p1.split('memo_id=')[1]
          return '<a href="' + encodeURI(p1) + '" slug="' + slug + '" class="inner_memo_link">MEMO</a>'
        },
      )
      // 排除 flomoapp.com/mine/?memo_id=xxx，flomoapp.com 链接可点
      matched = matched.replace(/(https?:\/\/([^\s<\/\#)）]+)[^\s<)）]*)/g, function (matchedLink, p1, p2) {
        if (p1.indexOf('flomoapp.com/mine/?memo_id=') > -1) return matchedLink
        return '<a href="' + p1 + '" target="_blank" class="blank_memo_link">' + p2 + '...</a>'
      })

      return matched
    })
    rendered_content = rendered_content.replace(/>([^>^<]*)/g, function (matched) {
      // 只匹配 html content
      matched = matched.replace(/#([^\s<#]+)/g, '<span class="tag">#$1</span>') // 标签可点
      return matched
    })
    var explorer = window.navigator.userAgent.toLowerCase()
    if (explorer.indexOf('chrome') < 0 && explorer.indexOf('safari') >= 0) {
      rendered_content = rendered_content.replace('<p></p>', '<p>&zwnj;</p>')
    }

    if (highlight_words) {
      let highlight_words_arr = highlight_words.split(' ')
      for (let i = 0; i < highlight_words_arr.length; i++) {
        let highlight_word = highlight_words_arr[i]
        let formatted_word = highlight_word.replace('>', '')
        formatted_word = formatted_word.replace('<', '')
        formatted_word = formatted_word.replace('', '')

        if (formatted_word) {
          formatted_word = formatted_word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') // 转义处理keyword包含的特殊字符，如 /.
          // | 为正则表达式的特殊字符，需要转义
          formatted_word = formatted_word.replace('|', '\\|')
          rendered_content = rendered_content.replace(/>(.*?)</g, function (matched) {
            // 只匹配 html content
            // return matched.replace(new RegExp(formatted_word, 'ig'), '<label class="highlight">$&</label>')
            const ranges = []
            highlight_words_arr.forEach((keyword) => {
              if (keyword === '') {
                return
              }
              keyword = MemoUtil.escapeSpecialChar(keyword)
              const pattern = new RegExp(`${keyword}`, 'ig')
              let match = pattern.exec(matched)
              while (match) {
                const start = match.index
                const end = start + keyword.length
                const matchText = match[0]
                ranges.push([start, end, matchText])
                match = pattern.exec(matched)
              }
            })
            const mergedRanges = MemoUtil.mergeRanges(ranges)
            let result = ''
            if (ranges.length > 0) {
              for (let i = 0; i < mergedRanges.length; i++) {
                const range = mergedRanges[i]
                const start = range[0]
                const end = range[1]
                const match = range[2]
                result += matched.substring(i > 0 ? mergedRanges[i - 1][1] : 0, start)
                result += `<label class="highlight">${match}</label>`

                if (i === mergedRanges.length - 1) {
                  result += matched.substring(end)
                }
              }
            } else {
              result = matched
            }
            return result
          })
        }
      }
    }

    return rendered_content
  }

  static mergeRanges(ranges) {
    const mergedRanges = []
    let currentRange = null
    ranges.sort((a, b) => a[0] - b[0]) // Sort ranges by start index
    for (const range of ranges) {
      if (!currentRange) {
        currentRange = [...range]
      } else if (range[0] <= currentRange[1]) {
        // Overlapping ranges
        currentRange[1] = Math.max(range[1], currentRange[1])
        // update the text in case the range is expanded
        const text =
          currentRange[2].slice(0, range[0] - currentRange[0]) +
          range[2] +
          currentRange[2].slice(range[1] - currentRange[0])
        currentRange[2] = text
      } else {
        // Non-overlapping range
        mergedRanges.push(currentRange)
        currentRange = [...range]
      }
    }
    if (currentRange) {
      mergedRanges.push(currentRange)
    }
    return mergedRanges
  }

  static getMemoUrl(memoSlug) {
    return 'https://v.flomoapp.com/mine/?memo_id=' + memoSlug
  }

  static getMemoWordCount(memoContent) {
    if (!memoContent) return 0
    // 过滤掉 html 标签
    let memoContentWithoutHtml = memoContent.replace(/<[^>]*>/g, '')

    return memoContentWithoutHtml.length
  }

  // 处理特殊字符
  static escapeSpecialChar(str) {
    if (!str) return str
    str = str.replace('>', '')
    str = str.replace('<', '')
    str = str.replace('', '')
    // | 为正则表达式的特殊字符，需要转义
    str = str.replace('|', '\\|')
    str = str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') // 转义处理keyword包含的特殊字符，如 /.
    return str
  }
}
